var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLinkedinSquare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.429 0H1.567C.702 0 0 .712 0 1.586v18.828C0 21.288.702 22 1.567 22h18.862c.864 0 1.571-.712 1.571-1.586V1.586C22 .712 21.293 0 20.429 0zM6.649 18.857H3.39V8.358h3.265v10.5H6.65zM5.02 6.924a1.891 1.891 0 010-3.781c1.04 0 1.89.85 1.89 1.89a1.888 1.888 0 01-1.89 1.891zm13.853 11.933h-3.26V13.75c0-1.218-.025-2.784-1.695-2.784-1.7 0-1.96 1.326-1.96 2.696v5.195h-3.26V8.358h3.128v1.434h.044c.437-.825 1.503-1.694 3.089-1.694 3.3 0 3.914 2.175 3.914 5.004v5.755z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedinSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin-square.523ded57.svg";
export { ForwardRef as ReactComponent };